import { motion, MotionProps } from "framer-motion";
import { useContext, useMemo } from "react";
import {
  Dialog,
  DialogProps,
  ModalOverlay,
  Modal as ModalRAC,
} from "react-aria-components";
import { ModalContext } from "./types";
import { cn } from "../../cn";

const MotionModal = motion(ModalRAC);
const MotionModalOverlay = motion(ModalOverlay);

interface ModalDialogProps extends DialogProps {
  containerClassName?: string;
  layoutId?: MotionProps["layoutId"];
  transition?: MotionProps["transition"];
  isDismissable?: boolean;
}

export default function ModalDialog({
  containerClassName,
  className,
  layoutId,
  transition,
  isDismissable = true,
  ...props
}: ModalDialogProps) {
  const { onComplete, animation, isOpen } = useContext(ModalContext);
  const container = useMemo(() => {
    if (typeof window === "undefined") return undefined;
    return document.getElementById("storybook-root") ?? document.body;
  }, []);
  return (
    <MotionModalOverlay
      className={`fixed top-0 left-0 w-screen h-screen isolate bg-black-0/50 backdrop-blur-md flex items-center justify-center z-[1000000] ${isOpen === false ? "pointer-events-none" : ""}`}
      onAnimationComplete={onComplete}
      UNSTABLE_portalContainer={container}
      isDismissable={isDismissable}
      variants={{
        hidden: { opacity: 0 },
        visible: { opacity: 1 },
      }}
      initial="hidden"
      animate={animation}
    >
      <MotionModal
        variants={{
          hidden: { opacity: 0, y: 50 },
          visible: { opacity: 1, y: 0 },
        }}
        layoutId={layoutId}
        transition={transition}
        className={cn("bg-white rounded-4 shadow-y-plus-5", containerClassName)}
      >
        <Dialog className={cn("outline-hidden", className)} {...props} />
      </MotionModal>
    </MotionModalOverlay>
  );
}
